import { render, staticRenderFns } from "./BloqueCodigo.vue?vue&type=template&id=f92a6b94&scoped=true"
import script from "./BloqueCodigo.vue?vue&type=script&lang=js"
export * from "./BloqueCodigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92a6b94",
  null
  
)

export default component.exports